import { Alert, Button, Spinner } from "reactstrap";
import { getAnalysisNotice, isAnalysisInProgress } from "../helpers/analysisStatus";
import usePositiveListAnalysisStatus from "../hooks/usePositiveListAnalysisStatus";
import useReanalyzePositiveList from "../hooks/useReanalyzePositiveList";

const PositiveListAnalysis = ({ softwareId, t }) => {
    const analysisQuery = usePositiveListAnalysisStatus({ softwareId, t });
    const reanalyzeMutation = useReanalyzePositiveList({ softwareId, t });
    const analysis = analysisQuery.data;
    const notice = getAnalysisNotice(analysis);
    const inProgress = isAnalysisInProgress(analysis?.status)
        || reanalyzeMutation.isLoading;

    return (
        <div className="positive-list__analysis">
            <div className="positive-list__analysis-main">
                <div>
                    <div className="positive-list__analysis-title">
                        {t("Re-analyze")}
                    </div>
                    <p className="positive-list__analysis-text">
                        {t(
                            "Re-analysis adds newly discovered measures and evidence. Existing Yes/No decisions and manual measures are kept."
                        )}
                    </p>
                </div>
                <Button
                    color="primary"
                    outline
                    className="positive-list__analysis-button"
                    disabled={inProgress}
                    onClick={() => reanalyzeMutation.mutate()}
                >
                    {inProgress && (
                        <Spinner size="sm" className="me-1" />
                    )}
                    {t("Re-analyze")}
                </Button>
            </div>

            {notice && (
                <Alert color={notice.color} className="positive-list__analysis-notice mb-0">
                    {t(notice.messageKey)}
                </Alert>
            )}
        </div>
    );
};

export default PositiveListAnalysis;
